<h2 mat-dialog-title>VIN limit reached</h2>

<mat-dialog-content>
  <p>
    Up to {{ data.max }} VINs can be looked up at once.
    {{ data.dropped.length }} {{ data.dropped.length === 1 ? 'VIN was' : 'VINs were' }} not added:
  </p>
  <ul class="dropped-list">
    @for (vin of data.dropped; track vin) {
      <li>{{ vin }}</li>
    }
  </ul>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    mat-button
    [cdkCopyToClipboard]="copyText"
    (cdkCopyToClipboardCopied)="copied.set($event)">
    <mat-icon>{{ copied() ? 'check' : 'content_copy' }}</mat-icon>
    {{ copied() ? 'Copied' : 'Copy dropped VINs' }}
  </button>
  <button mat-flat-button color="primary" mat-dialog-close>OK</button>
</mat-dialog-actions>
